/**
 * Get string translation
 * @param code
 * @param props
 * @param callbackArg
 */
window.__ = function (code, props = [], callbackArg = false) {
    if(typeof window.translations[code] === 'undefined') {
        console.warn(code + ' - translation not found');
        return '';
    }
    var translation = window.translations[code];
    if(typeof translation === 'function') {
        translation = translation(callbackArg);
    }
    $.each(props,(from, to) => {
        translation = translation.replace(from, to);
    });
    return translation;
}
if(typeof window.translations === 'undefined') {
    console.error('Translations not loaded');
}